"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));
var React = _interopRequireWildcard(require("react"));
var _reactLazyload = _interopRequireDefault(require("react-lazyload"));
var StyledImage = (0, _styledBase["default"])("img", {
  target: "e99w8gw0",
  label: "StyledImage"
})("border:0;", function (_ref) {
  var display = _ref.display;
  return display ? "display: ".concat(display, ";") : '';
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JbWFnZS9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJOEIiLCJmaWxlIjoiLi4vLi4vc3JjL0ltYWdlL2luZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0ICogYXMgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IExhenlMb2FkIGZyb20gJ3JlYWN0LWxhenlsb2FkJztcblxuY29uc3QgU3R5bGVkSW1hZ2UgPSBzdHlsZWQuaW1nYFxuICBib3JkZXI6IDA7XG4gICR7KHsgZGlzcGxheSB9KSA9PiAoZGlzcGxheSA/IGBkaXNwbGF5OiAke2Rpc3BsYXl9O2AgOiAnJyl9XG5gO1xuXG5jb25zdCBJbWFnZSA9ICh7IGlzTGF6eSwgbGF6eUhlaWdodCwgb2ZmU2V0LCAuLi5yZXN0IH0pID0+IHtcbiAgY29uc3QgaW1nSGVpZ2h0ID0gbGF6eUhlaWdodCB8fCAocmVzdCAmJiByZXN0LmhlaWdodCkgfHwgJzEwMCUnO1xuXG4gIFxuICByZXR1cm4gaXNMYXp5ID8gKFxuICAgIDxMYXp5TG9hZFxuICAgICAgaGVpZ2h0PXtpbWdIZWlnaHR9XG4gICAgICBvbmNlXG4gICAgICBvZmZzZXQ9e29mZlNldCA/IG9mZlNldCA6IDEwMH1cbiAgICA+XG4gICAgICA8U3R5bGVkSW1hZ2Ugey4uLnJlc3R9IC8+XG4gICAgPC9MYXp5TG9hZD5cbiAgKSA6IChcbiAgICA8U3R5bGVkSW1hZ2Ugey4uLnJlc3R9IC8+XG4gICk7XG59O1xuXG5JbWFnZS5kaXNwbGF5TmFtZSA9ICdJbWFnZSc7XG5cbkltYWdlLmRlZmF1bHRQcm9wcyA9IHtcbiAgaXNMYXp5OiBmYWxzZSxcbiAgbGF6eUhlaWdodDogbnVsbCxcbiAgb2ZmU2V0OiAxMDAsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBJbWFnZTtcbiJdfQ== */");
var Image = function Image(_ref2) {
  var isLazy = _ref2.isLazy,
    lazyHeight = _ref2.lazyHeight,
    offSet = _ref2.offSet,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, ["isLazy", "lazyHeight", "offSet"]);
  var imgHeight = lazyHeight || rest && rest.height || '100%';
  return isLazy ? React.createElement(_reactLazyload["default"], {
    height: imgHeight,
    once: true,
    offset: offSet ? offSet : 100
  }, React.createElement(StyledImage, rest)) : React.createElement(StyledImage, rest);
};
Image.displayName = 'Image';
Image.defaultProps = {
  isLazy: false,
  lazyHeight: null,
  offSet: 100
};
var _default = Image;
exports["default"] = _default;
Image.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Image",
  "props": {
    "isLazy": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "lazyHeight": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false
    },
    "offSet": {
      "defaultValue": {
        "value": "100",
        "computed": false
      },
      "required": false
    }
  }
};
if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["Image/index.js"] = {
    name: "Image",
    docgenInfo: Image.__docgenInfo,
    path: "Image/index.js"
  };
}